$(document).ready(function () {
    var preferences = window.GDPRactive == true && window.Cookies.get("cookieControlPrefs") != undefined ? $.gdprcookie.preference() : false;

    // toggle mobile menu
    $('button#toggle-menu').click(function () {

        var isAlreadyOpen = $("body").hasClass('show-mobile-menu');
        if (isAlreadyOpen)
        {
            // CLOSE MOBILE MENU
            $(this).removeClass('open');
            $(this).attr("aria-expanded", "false"); //A360 Issue 340: fix for screenreaders
            // add class to body
            $("body").removeClass('show-mobile-menu');
            // show overlay
            $(".overlay").removeClass('overlay-active');
        }
        else
        {
            // OPEN MOBILE MENU
            $(this).addClass('open');
            $(this).attr("aria-expanded", "true"); //A360 Issue 340: fix for screenreaders
            // add class to body
            $("body").addClass('show-mobile-menu');
            // show overlay
            $(".overlay").addClass('overlay-active');
            
        }

    });
  
    // header/brandswitch ONLOAD
    HandleScrollingAndScaling(this);

    // header+brandswitch ONSCROLL
    $(window).on("scroll", function () {
        HandleScrollingAndScaling(this);
    });
    $(window).on('resize', function () {
        HandleScrollingAndScaling(this);
    });

    // megamenu
    $(".toggle-megamenu").click(function() {
        
        var menuId = $(this).attr("data-menuid");
        var isVisible = $('#'+ menuId).is(':visible');
      
        // hide others
        $(".megamenuactive").removeClass("megamenuactive");
        $(".toggle-megamenu").removeClass("active");

        if (isVisible) {
             // hide megamenu
            $("#"+ menuId).removeClass("megamenuactive");
            // hide overlay
            $(".overlay").removeClass("overlay-active");
            // remove body megameny class 
            $("body").removeClass("megamenu-open");
           
         } else {
             // show megamenu
             $("#"+ menuId).addClass("megamenuactive");
             // show overlay
             $(".overlay").addClass("overlay-active");
            // add class to body for mobile scrolling
             $("body").addClass("megamenu-open");
            // add active class to link itself
             $(this).addClass("active")
            // add focus
             if (menuId == "megamenusearch") {
                 $("#megamenusearch form input").focus();
             }
        }
    });

    $(".close-megamenu a").click(function() {
        $(".megamenuactive").removeClass("megamenuactive");
        // body
        $("body").removeClass("megamenu-open");
        // hide overlay
        $(".overlay").removeClass("overlay-active");
    });

    $('.alert-inTestMode').mouseover(function () {
        $(this).text('Test mode');
    });

    $('.alert-inTestMode').mouseleave(function () {
        $(this).text('T');
    });

    $('.alert-inTestMode').click(function () {
        if (window.location.href.indexOf('localhost') > 0) {
            if (window.location.href.indexOf('mode=test') > 0) {
                window.location = window.location.href.replace("test", "normal")
            } else if (window.location.href.indexOf('mode=normal') > 0) {
                window.location = window.location.href.replace("normal", "test")
            } else {
                window.location = window.location.href + (window.location.href.indexOf('?') > 0 ? '&' : '?') + 'mode=normal'
            }
        } else {
            window.location = window.location.href.replace("test.", "www.")
        }
    });


    //$(".toggle-product-zoom").click(function () {
    //    var isActive = $(".product-zoom-window").hasClass("product-zoom-window-active")
    //    if (isActive == false)
    //    {
    //        // activate now
    //        $(".product-zoom-window").addClass("product-zoom-window-active");
    //        $("body").addClass("disable-scrollbar");
    //    }
    //    else
    //    {
    //        // deactivate
    //        $(".product-zoom-window").removeClass("product-zoom-window-active");
    //        $("body").removeClass("disable-scrollbar");
    //    }
    //         //$("#draggable").draggable();
    //});

    $('[data-analytics-link]').click(function (e) {
        if (window.GDPRactive == false || (preferences != false && preferences.indexOf('marketing') > -1)) {
            if (!ga.loaded)
                return;
            e.preventDefault();

            var $link;
            if ($(e.target).is('[data-analytics-link]'))
                $link = $(e.target);
            else
                $link = $(e.target).closest('[data-analytics-link]');

            window["AnalyticsBuilder"].create(window.inTestMode ? { debug: true } : {})
                .addProduct(createProduct($link.data()))
                .asClick($link.data('analyticsLink'))
                .send(function () {
                    window.location = $link[0].href;
                });
            console.log("*GDPR-marketing: data-analytics-link");
        }
    });

    $('[data-analytics-impression]').each(function (i, e) {
        if (window.GDPRactive == false || (preferences != false && preferences.indexOf('marketing') > -1)) {
            var impression = createProduct($(e).data());
            impression['list'] = $(e).data('analyticsImpression');
            impression['position'] = i + 1;

            window["AnalyticsBuilder"].create(window.inTestMode ? { debug: true } : {})
                .addImpression(impression)
                .send();
            console.log("*GDPR-marketing: data-analytics-impression");
        }
    });

    $('[data-analytics-event]').click(function (e) {
        if (window.GDPRactive == false || (preferences != false && preferences.indexOf('marketing') > -1)) {
            var $target = $(e.target).is('[data-analytics-event]') ? $(e.target)
                : $(e.target).closest('[data-analytics-event]');

            window["AnalyticsBuilder"].create(window.inTestMode ? { debug: true } : {})
                .asEvent().send({
                    type: 'event',
                    category: $target.data('analyticsEvent'),
                    action: 'Click',
                    label: $target.data('analyticsLabel')
                });
            console.log("*GDPR-marketing: data-analytics-event");
        }
    });
});

function createProduct(data) {
    var productData = {};
    for (var prop in data)
        if (prop.startsWith("product"))
            productData[prop.replace('product', '').toLowerCase()] = data[prop];
    return productData;
}

function HandleScrollingAndScaling(myObject) {

    // SCROLLING
    var distanceToTop = $(myObject).scrollTop();
  
    // header transparency + back to top link
    if (distanceToTop > lastScrollTop) {
        if (distanceToTop > 100) {
            $("body").addClass("scroll-mode-enabled");
        }
    } else {
        // upscroll code
        $("body").removeClass("scroll-mode-enabled");
    }
    lastScrollTop = distanceToTop;

    // RESIZING
    if ($(window).width() < 975) {
        $("body").addClass("mobile-mode-enabled");
    }
    else {
        $("body").removeClass("mobile-mode-enabled");
    }

}